var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-stage-status-item",class:{
    'px-stage-status-item--active': _vm.active,
    'px-stage-status-item--clickable': _vm.isClickable,
  },on:{"click":function($event){_vm.isClickable ? _vm.$emit('status-click') : null}}},[_c('PxIcon',{attrs:{"size":_vm.iconSize,"name":_vm.icon}}),_c('h3',{staticClass:"px-stage-status-item__title"},[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }